/*
Author : Raphaël Dardeau


Markup :

<div class="js-hscroll">
    <a href="#" class="js-hscroll-left"></a>
    <a href="#" class="js-hscroll-right"></a>
    <div class="js-hscroll-mask">
        <ul class="js-hscroll-list">
            <li class="js-tabs-item" data-tabs-load="content-1.html">
                <a href="/page-1/">
                    Page 1
                </a>
            </li>
            <li class="js-tabs-item" data-tabs-load="content-2.html">
                <a href="/page-2/">
                    Page 2
                </a>
            </li>
        </ul>
    </div>
</div>


Setup :

$(function() {
    $(".js-hscroll").navscrolling();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "navscrolling",
        defaults = {
            container: ".js-hscroll-mask",
            scroller: ".js-hscroll-list",
            controllerLeft: ".js-hscroll-left",
            controllerRight: ".js-hscroll-right",
            dblclick: false,
            autoTab: false
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        $(window).on("resize", $.proxy(function() {
            this.screenWidth = $(window).width();
            this.init();
        }, this));
        $(window).trigger("resize");
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.unsetEvents();
            this.setVars();
            this.setDefaultStyles();
            this.maxItemIndex = this.getMaxItemIndex();
            this.toCenter();
            this.setControllers();
            this.setEvents();
        },
        setElements: function() {
            this.$element = $(this.element);
            this.$container = this.$element.find(this.settings.container);
            this.$scroller = this.$element.find(this.settings.scroller);
            this.$items = this.$scroller.children();
            this.setActiveItem();
            this.$left = this.$element.find(this.settings.controllerLeft);
            this.$right = this.$element.find(this.settings.controllerRight);
        },
        setActiveItem: function() {
            this.$activeItem = this.$items.filter(".is-active");
            if(this.$items.filter(".is-activetoo").length> 0 )
            { this.$activeItem = this.$items.filter(".is-activetoo");}

            this.activeItemIndex = this.$items.index(this.$activeItem);
        },
        setVars: function() {
            this.scrollerHeight = this.$items.filter(":first").outerHeight();
            var scrollerWidth = 0;
            this.$items.each(function() {
                scrollerWidth += $(this).outerWidth(true);
            });
            this.scrollerWidth = scrollerWidth;
            this.visibleWidth = this.$container.width();
            this.itemNum = this.$items.length;
            this.currentItemIndex = 0;
        },
        getMaxItemIndex: function() {
            var plugin = this;
            var maxItemIndex = this.itemNum - 1;
            $(this.$items.get().reverse()).each(function() {
                if ($(this).position().left >= plugin.scrollerWidth - plugin.visibleWidth)
                    maxItemIndex = $(this).index();
            });
            return maxItemIndex;
        },
        setDefaultStyles: function() {
            this.$container.css({
                position:"relative",
                height:this.scrollerHeight,
                overflow:"hidden"
            });
            this.$scroller.css({
                position:"absolute",
                left:0,
                width:this.scrollerWidth
            });
        },
        unsetDefaultStyles: function() {
            this.$container.removeAttr("style");
            this.$scroller.removeAttr("style");
        },
        setControllers: function() {
            if (!this.settings.autoTab) {
                if (this.currentItemIndex === 0)
                    this.$left.addClass("is-disabled");
                else if (this.$left.hasClass("is-disabled"))
                    this.$left.removeClass("is-disabled");
                if (this.currentItemIndex >= this.maxItemIndex)
                    this.$right.addClass("is-disabled");
                else if (this.$right.hasClass("is-disabled"))
                    this.$right.removeClass("is-disabled");
            } else {
                if (!this.activeItemIndex)
                    this.$left.addClass("is-disabled");
                else if (this.$left.hasClass("is-disabled"))
                    this.$left.removeClass("is-disabled");
                if (!this.$items.eq(this.activeItemIndex + 1).length || this.scrollerWidth <= this.visibleWidth)
                    this.$right.addClass("is-disabled");
                else if (this.$right.hasClass("is-disabled"))
                    this.$right.removeClass("is-disabled");
            }
        },
        setEvents: function() {
            this.$left.on("click", $.proxy(this.toPrev, this))
            if (this.settings.dblclick)
                this.$left.on("dblclick", $.proxy(this.toStart, this));
            this.$right.on("click", $.proxy(this.toNext, this))
            if (this.settings.dblclick)
                this.$right.on("dblclick", $.proxy(this.toEnd, this));
            if ('ontouchstart' in window || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                var touchStart = 0,
                    touchEnd = 0,
                    currentItemWidth = this.$items.eq(this.currentItemIndex).width(),
                    _this = this;
                this.$scroller.on("touchstart", function (e) {
                    touchStart = e.originalEvent.touches[0].pageX;
                }).on("touchmove", function (e) {
                    touchEnd = e.originalEvent.touches[0].pageX;
                    if (touchStart - currentItemWidth >= touchEnd) {
                        _this.$right.trigger("click");
                        touchStart = touchEnd;
                        currentItemWidth = _this.$items.eq(_this.currentItemIndex).width();
                    } else if (touchStart + currentItemWidth <= touchEnd) {
                        _this.$left.trigger("click");
                        touchStart = touchEnd;
                        currentItemWidth = _this.$items.eq(_this.currentItemIndex).width();
                    }
                });
            }
        },
        unsetEvents: function() {
            this.$left.off("click").off("dblclick");
            this.$right.off("click").off("dblclick");
            if ('ontouchstart' in window || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
                this.$scroller.off("touchstart").off("touchmove");
        },
        toNext: function(e) {
            if (!this.$right.hasClass("is-disabled")) {
                this.setActiveItem();
                if (this.settings.autoTab && this.$items.eq(this.activeItemIndex + 1).length) {
                    this.activeItemIndex++;
                    this.$items.eq(this.activeItemIndex).trigger("click");
                }
                var newItemIndex = this.currentItemIndex + 1;
                this.slideTo(newItemIndex);
            }
            e.preventDefault();
        },
        toPrev: function(e) {
            if (!this.$left.hasClass("is-disabled")) {
                this.setActiveItem();
                if (this.settings.autoTab && this.$items.eq(this.activeItemIndex - 1).length) {
                    this.activeItemIndex--;
                    this.$items.eq(this.activeItemIndex).trigger("click");
                }
                var newItemIndex = this.currentItemIndex - 1;
                this.slideTo(newItemIndex);
            }
            e.preventDefault();
        },
        toStart: function(e) {
            if (!this.$right.hasClass("is-disabled"))
                this.slideTo(0);
            e.preventDefault();
        },
        toEnd: function(e) {
            if (!this.$right.hasClass("is-disabled"))
                this.slideTo(this.maxItemIndex);
            e.preventDefault();
        },
        toCenter: function() {
            this.setActiveItem();
            if (this.$activeItem.length) {
                var itemWidth = this.$items.first().width();
                var visibleItems = Math.floor(this.visibleWidth / itemWidth);
                var itemOffset = Math.round((visibleItems - 1) / 2);
                if (this.activeItemIndex > itemOffset) {
                    var offsetIndex = (this.activeItemIndex - itemOffset < this.maxItemIndex) ? this.activeItemIndex - itemOffset : this.maxItemIndex;
                    this.slideTo(offsetIndex);
                }
            }
        },
        slideTo: function(newItemIndex) {
            var offsetLeft = (newItemIndex > 0) ? this.$items.eq(newItemIndex).position().left * -1: 0;
            this.$scroller.css({left:offsetLeft});
            this.currentItemIndex = newItemIndex;
            this.setControllers();
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
